export default function preventDefault(cb) {
  return (e, ...args) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    return cb(...args);
  };
};
